import React from "react";
import ReactApexChart from "react-apexcharts";

interface GraphDetails {
    allData: {
        names: string;
        scores: string;
    };
}

const PsychologicalGraph: React.FC<GraphDetails> = ({ allData }) => {

    
    // Convert string → array
    const labels = allData?.names?.split(",") || [];
    const values = allData?.scores?.split(",").map(Number) || [];
    const tabVal = allData?.data || [];

    // Chart Options
    const optionsBar: any = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false }
        },

        plotOptions: {
            bar: {
                columnWidth: "45%",
                borderRadius: 4,
            }
        },

        xaxis: {
            categories: labels,   // ✅ IMPORTANT
            labels: {
                rotate: -30,
                style: { colors: "#777", fontSize: "12px" }
            }
        },

        yaxis: {
            min: 0,
            max: 30,
            tickAmount: 6,
            title: {
                text: "Scores"
            }
        },

        dataLabels: {
            enabled: false
        },

        colors: ["#1eb0d5"],

        tooltip: {
            y: {
                formatter: (val: number) => `${val}`
            }
        }
    };

    // Series (MANDATORY)
    const series = [
        {
            name: "Score",
            data: values
        }
    ];
    
    return (
        <div id="bar">
            <ReactApexChart
                options={optionsBar}
                series={series}
                type="bar"   // ✅ FIXED
                height={300}
                width="100%"
            />

            <table className="table table-bordered mt-4">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Interpretation</th>
                    </tr>
                </thead>
                <tbody>
                    {tabVal.map((item: any, index: number) => (
                        <tr key={index}>
                            <td>{item.name}</td>
                            <td className="text-wrap">{item.interpretation}</td>
                        </tr>
                    ))}

                </tbody>
            </table>

        </div>
    );
};

export default PsychologicalGraph;